module.exports = __webpack_public_path__ + "static/media/Brochure.c2fa7270.png";